import { ProtocoloAssunto } from './protocolo-assunto.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProtocoloAssuntoService {

    constructor(private http: Http){}

    getProtocoloAssuntos(): Observable<ProtocoloAssunto[]> {
        return this.http.get(`${NTECH_API}/protocolo-assunto`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/protocolo-assunto/protocolo-assunto.service.ts